<template>
    <ds-card class="start-from-scratch" data-qa="start-from-scratch">
        <div>
            <ds-illustration name="notes-gray" />
        </div>

        <strong>{{ $options.START_FROM_SCRATCH_TEXT }}</strong>

        <ds-outline-button data-qa="template-blank" @click="$emit('click-create')">
            {{ $options.START_FROM_SCRATCH_LABEL }}
        </ds-outline-button>
    </ds-card>
</template>
<script>
export const START_FROM_SCRATCH_LABEL = 'Start from scratch';
export const START_FROM_SCRATCH_TEXT = 'Don\'t want to start from a template?';
export default {
    START_FROM_SCRATCH_LABEL,
    START_FROM_SCRATCH_TEXT,
    name: 'StartFromScratchCard',
};
</script>

<style  lang="scss" rel="stylesheet/scss"  scoped>

  .start-from-scratch {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
      strong {
        margin: 1rem 0;
        text-align: center;
        font-size: $font-size-lg;
      }
  }

</style>
